<script>
import NairaSignIcon from '@core/components/naira-icon/NairaSignIcon.vue'
import * as icons from 'vue-feather-icons'

// Custom icons mapping
const customIcons = {
  NairaSignIcon,
}

export default {
  name: 'FeatherIcon',
  functional: true,
  props: {
    icon: {
      required: true,
      type: [String, Object],
    },
    size: {
      type: String,
      default: '14',
    },
    badge: {
      type: [String, Object, Number],
      default: null,
    },
    badgeClasses: {
      type: [String, Object, Array],
      default: 'badge-primary',
    },
  },
  render(h, { props, data }) {
    // Check if it's a custom icon first, then fall back to feather icons
    const IconComponent = customIcons[props.icon] || icons[props.icon]

    // Create Icon
    const svg = h(IconComponent, { props: { size: props.size }, ...data })

    // If no badge is provided => Render just SVG
    if (!props.badge) return svg

    // Badge
    const badgeEl = h('span', { staticClass: 'badge badge-up badge-pill', class: props.badgeClasses }, [props.badge])

    // Return span with children
    return h('span', { staticClass: 'feather-icon position-relative' }, [svg, badgeEl])
  },
}
</script>

<style lang="scss">
svg.feather {
  outline: none
}
</style>
